import { numberRound } from "./numberUtility";

const FILE_SIZES = ["B", "KB", "MB", "GB", "TB"];

/**
 * Format the file size from a number to a readable string
 */
export function formatFileSize(fileSize: number): string {
	if (fileSize == null) {
		return "";
	}

	const i = Math.floor(Math.log(fileSize) / Math.log(1024));
	const normalized = fileSize / Math.pow(1024, i);

	// if in B or KB, then just use whole number; otherwise add up to 2 decimal places
	const final = (i > 1) ? numberRound(normalized, 2) : Math.ceil(normalized);
	return `${final} ${FILE_SIZES[i]}`;
}

/**
 * Return name of file without its extension
 */
export function getFileNameWithoutExtension(filename: string, includePeriod = false): string {
	const a = filename.split(".");
	a.pop();
	const name = a.join(".");
	return includePeriod ? `${name}.` : name;
}

/**
 * Return filename extension
 */
export function getFileNameExtension(filename: string): string {
	return filename.split(".")
		.pop()
		.toLowerCase();
}

/** Convert data URL to blob URL */
export function dataURLtoBlobURL(url: string): string {
	const data = url.split(",")[1];
	const mimeType = url.split(";")[0].slice(5);

	const bytes = window.atob(data);
	const buf = new ArrayBuffer(bytes.length);
	const arr = new Uint8Array(buf);

	for (let i = 0; i < bytes.length; i++) {
		arr[i] = bytes.charCodeAt(i);
	}

	const blob = new Blob([arr], { type: mimeType });
	const blobUrl = URL.createObjectURL(blob);

	return blobUrl;
}

/** Fetches image via url and returns its blob as a File */
export async function getImageFile(url: string, fileName: string = "image.jpg"): Promise<File> {
	const imageBlob = await fetch(url).then((res) => res.blob());

	return new File([imageBlob], fileName, { type: imageBlob.type });
}